import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  GridCsvExportMenuItem,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import React, { useEffect, useState } from "react";
import { useDataGridSettings } from "../DataGridSettingsProvider";
import { useOptionalViewContext } from "../ViewProvider";
import { AdminViewActions } from "./CustomToolbar/AdminViewActions";
import AdvancedSettingsDropdown from "./CustomToolbar/AdvancedSettingDropdown";
import GridExcelExportMenuItem from "./CustomToolbar/GridExcelExportMenuItem";
import HelpLinkButton from "./CustomToolbar/HelpLinkButton";
import { ResetViewOverrideButton } from "./CustomToolbar/ResetViewOverrideButton";
import SaveTableButton from "./CustomToolbar/SaveTableButton";
import { SaveViewOverrideButton } from "./CustomToolbar/SaveViewOverrideButton";
import TableTemplates from "./CustomToolbar/TableTemplates";

const CustomToolbar = () => {
  const { pageType } = useDataGridSettings();
  const viewMode = !!useOptionalViewContext();
  const [showToolbarItems, setShowToolbarItems] = useState(true);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));

  useEffect(() => {
    setShowToolbarItems(!isMobile);
  }, [isMobile]);

  return (
    <GridToolbarContainer>
      {isMobile && (
        <IconButton
          onClick={() => setShowToolbarItems(!showToolbarItems)}
          size="small"
          sx={{ mr: 1 }}
        >
          {showToolbarItems ? <CloseIcon /> : <MenuIcon />}
        </IconButton>
      )}
      {showToolbarItems && (
        <>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
          <GridToolbarExportContainer>
            <GridCsvExportMenuItem />
            <GridExcelExportMenuItem />
          </GridToolbarExportContainer>
          {pageType !== "faultMonitor" && pageType !== "maintenance" && (
            <AdvancedSettingsDropdown />
          )}
          {viewMode ? (
            <>
              <SaveViewOverrideButton />
              <ResetViewOverrideButton />
              <AdminViewActions />
            </>
          ) : (
            <>
              <SaveTableButton />
              {pageType !== "maintenance" && <TableTemplates />}
            </>
          )}
          <HelpLinkButton />
          <Box sx={{ flexGrow: 1 }} />
          <GridToolbarQuickFilter />
        </>
      )}
    </GridToolbarContainer>
  );
};

export default CustomToolbar;
